export const PATH_TRANSLATIONS = {
  de: {
    'entire-house': 'ganzes-haus',
    'private-bedroom': 'privates-schlafzimmer',
    'shared-bedroom': 'mehrbettzimmer',
    'wi-fi': 'wlan',
    'central-heating': 'zentralheizung',
    dishwasher: 'geschirrspueler',
    'washing-machine': 'waschmaschine',
    microwave: 'mikrowelle',
    oven: 'ofen',
    'cable-tv': 'fernsehen',
    'air-conditioning': 'klimaanlage',
    'outdoor-area': 'aussenbereich',
    elevator: 'aufzug',
    accessibility: 'barrierefreiheit-benoetigt',
    'unfurnished-house': 'unmoebliertes-haus',
    'unfurnished-bedroom': 'unmoebliertes-schlafzimmer',
    'private-bathroom': 'privates-badezimmer',
    'single-bed': 'einzelbett',
    'double-bed': 'doppelbett',
    'twin-bed': 'zweibett',
    'three-plus-beds': 'drei-plus-betten',
    wardrobe: 'kleiderschrank',
    window: 'fenster',
    balcony: 'balkon',
    desk: 'schreibtisch',
    lock: 'schloss',
    residence: 'residenz',
    'pets-allowed': 'haustiere-erlaubt',
    'overnight-guests-allowed': 'ubernachtungsgaste-erlaubt',
    'smoking-allowed': 'rauchen-erlaubt'
  },
  en: {
    'entire-house': 'entire-house',
    'private-bedroom': 'private-bedroom',
    'shared-bedroom': 'shared-bedroom',
    'wi-fi': 'wi-fi',
    'central-heating': 'central-heating',
    dishwasher: 'dishwasher',
    'washing-machine': 'washing-machine',
    microwave: 'microwave',
    oven: 'oven',
    'cable-tv': 'tv',
    'air-conditioning': 'air-conditioning',
    'outdoor-area': 'outdoor-area',
    elevator: 'elevator',
    accessibility: 'accessibility-needs',
    'unfurnished-house': 'unfurnished-house',
    'unfurnished-bedroom': 'unfurnished-bedroom',
    'private-bathroom': 'private-bathroom',
    'single-bed': 'single-bed',
    'double-bed': 'double-bed',
    'twin-bed': 'twin-bed',
    'three-plus-beds': 'multiple-bed',
    wardrobe: 'wardrobe',
    window: 'window',
    balcony: 'balcony',
    desk: 'desk',
    lock: 'lock',
    residence: 'residence',
    'pets-allowed': 'pets-allowed',
    'overnight-guests-allowed': 'overnight-guests-allowed',
    'smoking-allowed': 'smoking-allowed'
  },
  es: {
    'entire-house': 'casa-entera',
    'private-bedroom': 'habitacion-privada',
    'shared-bedroom': 'habitacion-compartida',
    'wi-fi': 'wi-fi',
    'central-heating': 'calefaccion-central',
    dishwasher: 'lavavajillas',
    'washing-machine': 'lavadora',
    microwave: 'microondas',
    oven: 'horno',
    'cable-tv': 'television',
    'air-conditioning': 'aire-acondicionado',
    'outdoor-area': 'zona-al-aire-libre',
    elevator: 'ascensor',
    accessibility: 'nececidades-de-accesibilidad',
    'unfurnished-house': 'casa-sin-muebles',
    'unfurnished-bedroom': 'habitacion-sin-muebles',
    'private-bathroom': 'bano-privado',
    'single-bed': 'cama-individual',
    'double-bed': 'cama-doble',
    'twin-bed': 'dos-camas-individuales',
    'three-plus-beds': 'tres-o-mas-camas',
    wardrobe: 'armario',
    window: 'ventana',
    balcony: 'balcon',
    desk: 'escritorio',
    lock: 'candado',
    residence: 'residencia',
    'pets-allowed': 'mascotas-permitidas',
    'overnight-guests-allowed': 'invitados-de-la-noche-permitidos',
    'smoking-allowed': 'fumar-permitido'
  },
  fr: {
    'entire-house': 'maison-entiere',
    'private-bedroom': 'chambre-privee',
    'shared-bedroom': 'chambre-partagee',
    residence: 'residence',
    'wi-fi': 'wi-fi',
    'central-heating': 'chauffage-central',
    dishwasher: 'lave-vaisselle',
    'washing-machine': 'machine-a-laver',
    microwave: 'micro-ondes',
    oven: 'four',
    'cable-tv': 'tv-cablee',
    'air-conditioning': 'climatisation',
    'outdoor-area': 'espace-exterieur',
    elevator: 'ascenseur',
    accessibility: 'accessibilite',
    'unfurnished-house': 'maison-non-meublee',
    'unfurnished-bedroom': 'chambre-non-meublee',
    'private-bathroom': 'salle-de-bain-privee',
    'single-bed': 'lit-simple',
    'double-bed': 'lit-double',
    'twin-bed': 'deux-lits-simples',
    'three-plus-beds': 'trois-ou-plus-lits',
    wardrobe: 'armoire',
    window: 'fenetre',
    balcony: 'balcon',
    desk: 'bureau',
    lock: 'cadenas',
    'pets-allowed': 'animaux-autorises',
    'overnight-guests-allowed': 'invites-de-nuit-autorises',
    'smoking-allowed': 'fumer-autorise'
  },
  it: {
    'entire-house': 'casa-intera',
    'private-bedroom': 'camera-da-letto-privata',
    'shared-bedroom': 'camera-da-letto-condivisa',
    'wi-fi': 'wi-fi',
    'central-heating': 'riscaldamento-centralizzato',
    dishwasher: 'lavastoviglie',
    'washing-machine': 'lavatrice',
    microwave: 'microonde',
    oven: 'forno',
    'cable-tv': 'tv',
    'air-conditioning': 'aria-condizionata',
    'outdoor-area': 'spazio-esterno',
    elevator: 'ascensore',
    accessibility: 'bisogni-di-accessibilita',
    'unfurnished-house': 'casa-non-mobilata',
    'unfurnished-bedroom': 'camera-non-mobilata',
    'private-bathroom': 'bagno-privato',
    'single-bed': 'letto-singolo',
    'double-bed': 'letto-matrimoniale',
    'twin-bed': 'letti-gemelli',
    'three-plus-beds': 'tre-o-piu-letti',
    wardrobe: 'armadio',
    window: 'finestra',
    balcony: 'balcone',
    desk: 'scrivania',
    lock: 'serratura',
    residence: 'residenza',
    'pets-allowed': 'animali-consentiti',
    'overnight-guests-allowed': 'ospiti-per-la-notte-consentiti',
    'smoking-allowed': 'fumare-consentito'
  },
  nl: {
    'entire-house': 'geheel-huis',
    'private-bedroom': 'eigen-slaapkamer',
    'shared-bedroom': 'gedeelde-slaapkamer',
    'wi-fi': 'wifi',
    'central-heating': 'centrale-verwarming',
    dishwasher: 'vaatwasmachine',
    'washing-machine': 'wasmachine',
    microwave: 'magnetron',
    oven: 'oven',
    'cable-tv': 'tv',
    'air-conditioning': 'airconditioning',
    'outdoor-area': 'buitenruimte',
    elevator: 'lift',
    accessibility: 'toegankelijkheidseisen',
    'unfurnished-house': 'ongemeubileerd-huis',
    'unfurnished-bedroom': 'ongemeubileerde-slaapkamer',
    'private-bathroom': 'ensuite-badkamer',
    'single-bed': 'eenpersoonsbed',
    'double-bed': 'tweepersoonsbed',
    'twin-bed': 'tweepersoonsbedden',
    'three-plus-beds': 'drie-of-meer-bedden',
    wardrobe: 'garderobe',
    window: 'raam',
    balcony: 'balkon',
    desk: 'bureau',
    lock: 'slot',
    residence: 'residence',
    'pets-allowed': 'huisdieren-toegestaan',
    'overnight-guests-allowed': 'loges-toegestaan',
    'smoking-allowed': 'roken-toegestaan'
  },
  pl: {
    'entire-house': 'caly-dom',
    'private-bedroom': 'prywatna-sypialnia',
    'shared-bedroom': 'wspolna-sypialnia',
    'wi-fi': 'wi-fi',
    'central-heating': 'centralne-ogrzewanie',
    dishwasher: 'zmywarka',
    'washing-machine': 'pralka',
    microwave: 'kuchenka-mikrofalowa',
    oven: 'piekarnik',
    'cable-tv': 'telewizja',
    'air-conditioning': 'klimatyzacja',
    'outdoor-area': 'podworko-lub-ogrod',
    elevator: 'winda',
    accessibility: 'potrzeby-dotyczace-dostepnosci',
    'unfurnished-house': 'nieumeblowany-dom',
    'unfurnished-bedroom': 'nieumeblowana-sypialnia',
    'private-bathroom': 'pokoj-z-lazienka',
    'single-bed': 'lozko-jednoosobowe',
    'double-bed': 'podwojne-lozko',
    'twin-bed': 'dwa-lozka-pojedyncze',
    'three-plus-beds': 'trzy-lozka-i-wiecej',
    wardrobe: 'szafa',
    window: 'okno',
    balcony: 'balkon',
    desk: 'biurko',
    lock: 'zamek',
    residence: 'residence',
    'pets-allowed': 'psy-sa-dozwolone',
    'overnight-guests-allowed': 'goscie-na-noc-dozwolone',
    'smoking-allowed': 'palenie-dozwolone'
  },
  pt: {
    'entire-house': 'casa-inteira',
    'private-bedroom': 'quarto-privado',
    'shared-bedroom': 'quarto-compartilhado',
    'wi-fi': 'wi-fi',
    'central-heating': 'aquecimento-central',
    dishwasher: 'maquina-de-lavar-loica',
    'washing-machine': 'maquina-de-lavar-roupa',
    microwave: 'micro-ondas',
    oven: 'forno',
    'cable-tv': 'televisao',
    'air-conditioning': 'ar-condicionado',
    'outdoor-area': 'area-exterior',
    elevator: 'elevador',
    accessibility: 'necessidades-de-mobilidade',
    'unfurnished-house': 'casa-nao-mobilada',
    'unfurnished-bedroom': 'quarto-nao-mobilado',
    'private-bathroom': 'casa-de-banho-privativa',
    'single-bed': 'cama-de-solteiro',
    'double-bed': 'cama-de-casal',
    'twin-bed': 'duas-camas',
    'three-plus-beds': 'tres-ou-mais-camas',
    wardrobe: 'guarda-roupa',
    window: 'janela',
    balcony: 'varanda',
    desk: 'secretaria',
    lock: 'chave',
    residence: 'residencia',
    'pets-allowed': 'animais-de-estimacao-permitidos',
    'overnight-guests-allowed': 'visitas-para-pernoitar-permitidas',
    'smoking-allowed': 'fumar-permitido'
  },
  zh: {
    'entire-house': '整栋房子',
    'private-bedroom': '私人卧室',
    'shared-bedroom': '共用卧室',
    'wi-fi': '无线网络',
    'central-heating': '中央供暖',
    dishwasher: '洗碗机',
    'washing-machine': '洗衣机',
    microwave: '微波炉',
    oven: '烤箱',
    'cable-tv': '有线电视',
    'air-conditioning': '空调',
    'outdoor-area': '户外区域',
    elevator: '电梯',
    accessibility: '无障碍设施',
    'unfurnished-house': '未装修的房子',
    'unfurnished-bedroom': '未装修的卧室',
    'private-bathroom': '私人浴室',
    'single-bed': '单人床',
    'double-bed': '双人床',
    'twin-bed': '两张单人床',
    'three-plus-beds': '超过3张床',
    wardrobe: '衣柜',
    window: '窗户',
    balcony: '阳台',
    desk: '台',
    lock: '锁',
    residence: '住宅',
    'pets-allowed': '宠物允许',
    'overnight-guests-allowed': '过夜客人',
    'smoking-allowed': '允许吸烟'
  }
};

export const PATH_QUERY_MAP = {
  'rent-type': {
    pathKeys: {
      property: 'entire-house',
      unit: 'private-bedroom',
      subunit: 'shared-bedroom'
    },
    isArray: true
  },
  'housing-type': {
    pathKeys: {
      residence: 'residence'
    },
    isArray: true
  },
  'property-features': {
    pathKeys: {
      'wi-fi': 'wi-fi',
      'central-heating': 'central-heating',
      dishwasher: 'dishwasher',
      'washing-machine': 'washing-machine',
      microwave: 'microwave',
      oven: 'oven',
      'cable-tv': 'cable-tv',
      'air-conditioning': 'air-conditioning',
      'outdoor-area': 'outdoor-area',
      elevator: 'elevator',
      accessibility: 'accessibility',
      unfurnished: 'unfurnished-house'
    },
    isArray: true
  },
  rules: {
    pathKeys: {
      'pets-allowed': 'pets-allowed',
      'overnight-guests-allowed': 'overnight-guests-allowed',
      'smoking-allowed': 'smoking-allowed'
    },
    isArray: true
  },
  ensuite: {
    pathKeys: {
      true: 'private-bathroom'
    },
    isArray: false
  },
  'bed-type': {
    pathKeys: {
      'single-bed': 'single-bed',
      'double-bed': 'double-bed',
      'twin-bed': 'twin-bed',
      'multiple-bed': 'three-plus-beds'
    },
    isArray: true
  },
  'offer-features': {
    pathKeys: {
      wardrobe: 'wardrobe',
      window: 'window',
      balcony: 'balcony',
      desk: 'desk',
      lock: 'lock',
      unfurnished: 'unfurnished-bedroom'
    },
    isArray: true
  }
};
